import { createFileRoute } from '@tanstack/react-router'

export interface PortalLockedSearch {
  feature?: string
}

export const Route = createFileRoute('/portal/locked')({
  validateSearch: (search: Record<string, unknown>): PortalLockedSearch => ({
    feature: typeof search.feature === 'string' ? search.feature : undefined,
  }),
})
